// Italian
export const it = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portale cliente',
  'app.signOut':        'Esci',

  'login.email':        'E-mail',
  'login.password':     'Password',
  'login.signIn':       'Accedi',
  'login.signingIn':    'Accesso in corso…',
  'login.failed':       'Accesso non riuscito',
  'login.newAccount':   'Nuovo su Kardolive?',
  'login.createAccount':'Crea un account gratuito →',

  'nav.workspace':      'Spazio di lavoro',
  'nav.templates':      'Modelli',
  'nav.live':           'Live',
  'nav.rooms':          'Stanze e chat',
  'nav.content':        'Contenuti',
  'nav.developer':      'Sviluppatore',
  'nav.account':        'Account',

  'nav.overview':       'Panoramica',
  'nav.projects':       'Progetti',
  'nav.chat':           'Console chat',
  'nav.sessions':       'Sessioni',
  'nav.streams':        'Trasmissioni in diretta',
  'nav.studio':         'Studio',
  'nav.recordings':     'Registrazioni',
  'nav.apiKeys':        'Chiavi API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Tester di webhook',
  'nav.networkTest':    'Test di rete',
  'nav.embed':          'Widget incorporati',
  'nav.sdk':            'SDK e documentazione',
  'nav.docs':           'Documentazione',
  'nav.analytics':      'Analisi',
  'nav.settings':       'Impostazioni',

  'overview.welcome':       'Bentornato, {name}',
  'overview.plan':          '{tenant} · piano {plan}',
  'overview.newStream':     'Nuova trasmissione',
  'overview.kpi.live':           'In diretta ora',
  'overview.kpi.live.broadcasting': 'trasmissioni in corso',
  'overview.kpi.live.nothing':    'nulla in diretta',
  'overview.kpi.total':           'Trasmissioni totali',
  'overview.kpi.total.sub':       'di sempre',
  'overview.kpi.sessions':        'Sessioni · 30 giorni',
  'overview.kpi.sessions.sub':    'eventi di pubblicazione',
  'overview.kpi.recordings':      'Registrazioni',
  'overview.kpi.recordings.sub':  'pronte alla riproduzione',
  'overview.recentStreams':       'Trasmissioni recenti',
  'overview.recentSessions':      'Sessioni recenti',
  'overview.viewAll':             'Vedi tutto →',
  'overview.empty.title':         'Nessuna trasmissione',
  'overview.empty.body':          'Crea la tua prima trasmissione per iniziare.',
  'overview.empty.action':        'Crea trasmissione',
  'overview.noSessions':          'Nessuna sessione',

  'status.live':        'IN DIRETTA',
  'status.idle':        'INATTIVO',
  'status.ended':       'TERMINATO',
  'status.archived':    'ARCHIVIATO',

  'common.save':        'Salva',
  'common.cancel':      'Annulla',
  'common.delete':      'Elimina',
  'common.edit':        'Modifica',
  'common.create':      'Crea',
  'common.confirm':     'Conferma',
  'common.loading':     'Caricamento…',
  'common.error':       'Errore',
  'common.retry':       'Riprova',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Vai al contenuto della pagina",
  "nav.streamTemplates": "Modelli di trasmissione",
  "nav.boards": "Lavagne interattive",
  "nav.menu": "Apri navigazione",
  "nav.closeMenu": "Chiudi navigazione",
  "nav.scenarios": "Scenari",
  "nav.premieres": "Prime visioni",
  "nav.clips": "Clip",
  "dashboard.account": "Account",
  "dashboard.language": "Lingua",
  "dashboard.appearance": "Aspetto",
  "nav.allStreams": "Tutte le trasmissioni",
  "nav.destinations": "Destinazioni",
  "nav.ecommerce": "E-commerce",
  "nav.products": "Prodotti",
  "nav.services": "Servizi",
  "nav.collections": "Collezioni",
  "nav.orders": "Ordini",
  "nav.commerceSettings": "Impostazioni commerciali",
  "nav.engagement": "Interazione",
  "theme.light": "Passa alla modalità chiara",
  "theme.dark": "Passa alla modalità scura",
  "role.owner": "Proprietario",
  "role.admin": "Amministratore",
  "role.member": "Membro",
  "role.viewer": "Osservatore",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Attivi",
  "streams.archived": "Archiviati",
  "streams.monitor": "Monitor dei segnali",
  "streams.create": "Crea diretta",
  "streams.list": "Elenco",
  "streams.grid": "Griglia",
  "streams.view": "Vista delle dirette",
  "streams.searchLabel": "Cerca eventi",
  "streams.searchHint": "Cerca per nome",
  "streams.solutionFilter": "Filtra eventi per tipo",
  "streams.statusFilter": "Filtra eventi per stato",
  "streams.dateFilter": "Filtra per data di creazione",
  "streams.allSolutions": "Tutti i tipi",
  "streams.custom": "Configurazione esistente o personalizzata",
  "streams.allStatuses": "Tutti gli stati",
  "streams.anyTime": "Qualsiasi data di creazione",
  "streams.last7": "Creati negli ultimi 7 giorni",
  "streams.last30": "Creati negli ultimi 30 giorni",
  "streams.count": "Visualizzati {shown} eventi su {total}",
  "streams.noMatch": "Nessun evento corrisponde ai filtri.",
  "streams.clearFilters": "Cancella filtri",
  "streams.refreshFailed": "Impossibile aggiornare l’elenco",
  "streams.loadFailed": "Impossibile caricare le dirette",
  "streams.stale": "È visualizzato l’ultimo elenco caricato. Gli stati potrebbero essere cambiati.",
  "streams.connectionHint": "Controlla la connessione e ricarica l’elenco.",
  "streams.retrying": "Nuovo tentativo…",
  "streams.retry": "Riprova",
  "streams.restoreFailed": "Impossibile ripristinare la diretta",
  "streams.restoreHint": "Controlla la connessione e aggiorna l’elenco per verificare lo stato prima di riprovare.",
  "streams.unused": "Dirette inutilizzate: {count}",
  "streams.unusedHint": "Nessuna trasmissione o replica. Archivia per riordinare l’elenco; nulla viene eliminato.",
  "streams.reviewArchive": "Controlla e archivia",
  "streams.loading": "Caricamento delle dirette…",
  "streams.archiveEmpty": "Nessun elemento archiviato. Le dirette archiviate e le relative repliche restano qui fino al ripristino.",
  "streams.restore": "Ripristina",
  "streams.firstTitle": "Crea la tua prima diretta",
  "streams.firstBody": "Scegli una configurazione per vendite, lezioni o servizi, oppure parti da zero. Trasmetti dal browser, dal telefono o da OBS.",
  "streams.blank": "Diretta vuota",
  "streams.broadcasts": "Trasmissioni: {count}",
  "streams.replays": "Repliche: {count}",
  "streams.sessions": "Sessioni: {count}",
  "streams.recordings": "Registrazioni: {count}",
  "streams.mode.BROADCAST": "Trasmissione",
  "streams.mode.LOW_LATENCY": "Bassa latenza",
  "streams.mode.REALTIME": "Tempo reale",
  "streams.key": "Chiave",
  "streams.archiveTitle": "Archivia dirette inutilizzate",
  "streams.archiveHint": "Queste dirette non sono mai state trasmesse. Puoi ripristinarle in qualsiasi momento dalla scheda Archiviati.",
  "streams.archiveFailed": "Impossibile archiviare {count} dirette: potrebbero essere iniziate. Le altre sono state archiviate.",
  "streams.archiving": "Archiviazione…",
  "streams.archiveCount": "Archivia {count}",
  "streamType.webinar": "Webinar e lanci aziendali",
  "streamType.classroom": "Lezioni e tutoraggio",
  "streamType.training": "Formazione aziendale",
  "streamType.conference": "Conferenze e fiere",
  "streamType.shopping": "Shopping in diretta",
  "streamType.auction": "Aste in diretta",
  "streamType.consultation": "Consulenze private",
  "streamType.creator": "Dirette di creator e comunità",
  "streamType.audio": "Stanze audio e podcast",
  "streamType.sports": "Sport ed esport",
  "streamType.performance": "Concerti e spettacoli",
  "streamType.community": "Culto e raccolta fondi",
  "streamType.tour": "Visite e dimostrazioni",
  "streamType.fitness": "Fitness e laboratori",
  "streamType.public-meeting": "Notizie e riunioni pubbliche",
  "streamType.continuous": "Canali continui e telecamere",
  "streams.close": "Chiudi",
};
